import css from './header.scss';
import Button from '../../components/button/button';
import auth from '../../store/auth.js'
import { observer } from 'mobx-react';
import { useHistory } from "react-router-dom";
import Logo from '../../components/logo/logo';
import olga from '../../assets/images/avatars/olga_avatar.jpg'

const Header = observer((props) => {
    const history = useHistory();
    return (
        <header className={css.root}>
            <div className={css.container}>
                <div className={css.inner}>
                    <Logo />
                    <Button avatar style={css.logoutBtn} onClick={auth.isLoggedIn ? () => { history.push("/"); auth.logout(); } : () => { auth.login(); }}
                        caption={auth.isLoggedIn ? 'Выйти' : 'На главную'} img={auth.isLoggedIn ? olga : null}>
                    </Button>
                </div>
            </div>
        </header>
    );
});

export default Header;